// @flow
const IconBackToTop = `
    <svg
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 24 24"
        xml:space="preserve"
        width="16"
        height="16"
    >
        <polyline
            fill="none"
            stroke-width="1.5"
            points="23,18.5 12,10.5 1,18.5 "
        />
        <line stroke-width="1.5" x1="1" y1="5.5" x2="23" y2="5.5" />
    </svg>`;

export default IconBackToTop;
